<template>
    <div class="bg">
        <v-container fluid>
            <v-row class="mx-10 mt-6" justify="center">
                    <v-card width="650">
                    <v-toolbar style="background-color: #0d2155;" role="banner">

                        <v-toolbar-title class="text-white">
                            <img style="min-width: 315px; position: absolute; margin-top: -10px;" class="" width="315"
                                height="25" src="../img/partner-dell-white.png" alt="Dell Technologies Partner Program Logo" />
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="white" class="text-none" aria-label="Select language">

                            <LanguagePlaceholder is-html
                                default-text="Languages" />
                            <v-menu activator="parent" transition="scale-transition" location="bottom" aria-label="Language selection menu">
                                <v-list role="menu">
                                    <v-list-item v-for="(item, index) in languageItems" :key="index" :value="index"
                                        @click="selectLanguage(item)" role="menuitem">
                                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="">
                        <v-row>
                            <v-col>
                                <div class="text-h6">
                                    <LanguagePlaceholder is-html
                                        default-text="Register For RISE" />
                                </div>
                                <div class="text-body-2">
                                    <LanguagePlaceholder is-html
                                        default-text="Trouble registering? Contact" />
                                    <a
                                        href="mailto:support@dellpartnerincentives.com">support@dellpartnerincentives.com</a>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-window v-model="processWindow">
                                    <v-window-item value="captcha">
                                        <v-card>
                                            <v-card-text>
                                                <vue-hcaptcha sitekey="776658a4-c4ba-4c88-8c98-de0a61104618"
                                                    @verify="updateCaptchaToken" aria-label="Complete CAPTCHA verification">
                                                </vue-hcaptcha>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-btn class="text-none" @click="goTo('login')" width="100"
                                                    variant="tonal">
                                                    <LanguagePlaceholder 
                                                        is-html :element-visible="processWindow == 'captcha'"
                                                        default-text="Cancel" />

                                                </v-btn>
                                                <v-spacer></v-spacer>
                                                <v-btn class="text-none" width="100"
                                                    @click="processWindow = 'dell-partner'"
                                                    :disabled="captchaSuccess == false" color="#055699"
                                                    variant="elevated">
                                                    <LanguagePlaceholder 
                                                        is-html :element-visible="processWindow == 'captcha'"
                                                        default-text="Next" />
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-window-item>
                                    <v-window-item value="dell-partner">
                                        <v-card>
                                            <v-card-text>
                                                <div>
                                                    <LanguagePlaceholder 
                                                        is-html :element-visible="processWindow == 'dell-partner'"
                                                        default-text="To Register for The RISE Incentive Program, please complete the following information. All fields marked with * are mandatory." />
                                                </div>
                                                <br>
                                                <div>
                                                    <LanguagePlaceholder 
                                                        is-html :element-visible="processWindow == 'dell-partner'"
                                                        default-text="Please note that system generated emails are used to communicate important information such as registration details; these are an integral part of this loyalty programme and are not marketing emails." />
                                                </div>
                                                <br>
                                                <v-radio-group class="ml-0 mt-2" inline v-model="isDellPartner" 
                                                    aria-label="Are you a Dell Technologies Authorized Partner?" aria-required="true">
                                                    <template v-slot:label>
                                                        <LanguagePlaceholder
                                                            is-html
                                                            :element-visible="processWindow == 'dell-partner'"
                                                            default-text="* Are you a Dell Technologies Authorized Partner?" />
                                                    </template>
                                                    <v-radio :value="true" color="#0672cb">
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder
                                                                is-html
                                                                :element-visible="processWindow == 'dell-partner'"
                                                                default-text="Yes" />
                                                        </template>
                                                    </v-radio>
                                                    <v-radio :value="false" color="#0672cb">
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder
                                                             is-html
                                                                :element-visible="processWindow == 'dell-partner'"
                                                                default-text="No" />
                                                        </template>
                                                    </v-radio>
                                                </v-radio-group>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-btn class=text-none @click="goTo('login')" width="100"
                                                    variant="tonal">
                                                    <LanguagePlaceholder 
                                                        is-html :element-visible="processWindow == 'dell-partner'"
                                                        default-text="Cancel" />
                                                </v-btn>
                                                <v-spacer></v-spacer>
                                                <v-btn @click="processWindow = 'captcha'" width="100" variant="text"
                                                    class="mx-2 text-none">Back</v-btn>
                                                <v-btn class="text-none" width="100"
                                                    @click="processWindow = 'affinity-id-lookup'"
                                                    :disabled="isDellPartner == null" color="#055699"
                                                    variant="elevated">
                                                    <LanguagePlaceholder 
                                                        is-html :element-visible="processWindow == 'dell-partner'"
                                                        default-text="Next" />
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-window-item>
                                    <v-window-item value="affinity-id-lookup">
                                        <v-card>
                                            <v-card-text>
                                                <div>
                                                    <p>
                                                        <LanguagePlaceholder
                                                             is-html
                                                            :element-visible="processWindow == 'affinity-id-lookup'"
                                                            default-text="Please enter your Dell Technologies Affinity ID" />

                                                    </p>
                                                    <br>
                                                    <p>
                                                        <v-text-field variant="outlined"
                                                            :color="affinityIdChecked ? 'green-lighten-1' : undefined"
                                                            :bg-color="affinityIdChecked ? 'green-lighten-5' : undefined"
                                                            v-model="affinityId" clearable
                                                            @click:clear="affinityIdChecked = false"
                                                            :readonly="affinityIdChecked == true">

                                                            <template v-slot:append-inner>

                                                                <v-btn @click="checkAffinityId" variant="text"
                                                                    class="text-none" size="small"
                                                                    :color="affinityIdChecked ? 'green-darken-3' : undefined">
                                                                    <LanguagePlaceholder
                                                                        is-html
                                                                        :element-visible="processWindow == 'affinity-id-lookup'"
                                                                        default-text="Search" />
                                                                </v-btn>
                                                            </template>
                                                        </v-text-field>
                                                    </p>
                                                    <p v-if="affinityIdChecked">
                                                        <v-alert :text="selectedOrganization.accountName" type="success"
                                                            variant="outlined"></v-alert>
                                                    </p>
                                                    <p v-if="affinityIdChecked != true">
                                                        <v-btn @click="processWindow = 'choose-registration-method'"
                                                            block class="text-none" color="#055699" variant="tonal">
                                                            <LanguagePlaceholder
                                                             is-html
                                                                :element-visible="processWindow == 'affinity-id-lookup'"
                                                                default-text="Click here if you do not know your Affinity ID" />
                                                        </v-btn>
                                                    </p>
                                                    <p v-if="affinityIdChecked" class="mt-6">
                                                        <v-text-field variant="outlined"
                                                            :color="emailDomainFound ? 'green-lighten-1' : undefined"
                                                            :bg-color="emailDomainFound ? 'green-lighten-5' : undefined"
                                                            v-model="registerEmailAddress" clearable
                                                            @click:clear="emailDomainFound = false"
                                                            :readonly="emailDomainFound == true">
                                                            <template v-slot:label>
                                                                <LanguagePlaceholder
                                                                    is-html
                                                                    :element-visible="processWindow == 'affinity-id-lookup'"
                                                                    default-text="Enter business email address" />
                                                            </template>
                                                            <template v-slot:append-inner>
                                                                <v-btn @click="searchEmailDomain" variant="text"
                                                                    class="text-none" size="small"
                                                                    :color="affinityIdChecked ? 'green-darken-3' : undefined">
                                                                    <LanguagePlaceholder
                                                                        is-html
                                                                        :element-visible="processWindow == 'affinity-id-lookup'"
                                                                        default-text="Search" />
                                                                </v-btn>
                                                            </template>
                                                        </v-text-field>
                                                    </p>
                                                </div>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-btn class="text-none" @click="goTo('login')" width="100"
                                                    variant="tonal">
                                                    <LanguagePlaceholder 
                                                        is-html :element-visible="processWindow == 'affinity-id-lookup'"
                                                        default-text="Cancel" />
                                                </v-btn>
                                                <v-spacer></v-spacer>

                                                <v-btn @click="processWindow = 'dell-partner'" width="100"
                                                    variant="text" class="mx-2 text-none">Back</v-btn>
                                                <v-btn class="text-none" width="100"
                                                    @click="moveToCaptureRegistrationInfo"
                                                    :disabled="affinityIdChecked == false || emailDomainFound == false || (isExistingOrganization === true && isExistingOrganizationActive != true)"
                                                    color="#055699" variant="elevated">
                                                    <LanguagePlaceholder 
                                                        is-html :element-visible="processWindow == 'affinity-id-lookup'"
                                                        default-text="Next" />
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-window-item>
                                    <v-window-item value="choose-registration-method">
                                        <v-container fluid>
                                            <v-row>
                                                <LanguagePlaceholder 
                                                    is-html
                                                    :element-visible="processWindow == 'choose-registration-method'"
                                                    default-text="Visit the Dell Partner Portal to retrieve your Affinity ID" />

                                                <v-spacer></v-spacer>
                                                <v-btn class="text-none" @click="openDellPartnerPortal()" width="100"
                                                    color="#055699">Go</v-btn>

                                            </v-row>
                                            
                                            <v-row class="mt-6">
                                                <v-spacer></v-spacer>
                                                <v-btn @click="processWindow = 'affinity-id-lookup'" width="100"
                                                    variant="text" class="mx-2 text-none">Back</v-btn>
                                                <v-btn class="text-none" @click="goTo('login')" width="100"
                                                    variant="outlined">
                                                    <LanguagePlaceholder 
                                                        is-html
                                                        :element-visible="processWindow == 'choose-registration-method'"
                                                        default-text="Cancel" />
                                                </v-btn>
                                            </v-row>
                                        </v-container>
                                    </v-window-item>
                                    <v-window-item value="capture-registration-info">
                                        <v-card>
                                            <v-card-title>
                                                <LanguagePlaceholder is-html
                                                    :element-visible="processWindow == 'capture-registration-info'"
                                                    default-text="Dell Performance Portal Registration" />

                                            </v-card-title>
                                            <v-card-text>
                                                <p>
                                                    <LanguagePlaceholder 
                                                        is-html
                                                        :element-visible="processWindow == 'capture-registration-info'"
                                                        default-text="<p>To register for the Dell Performance Portal please enter the information below.</p><br><p>By registering, you agree to receive information (by email) regarding your Dell Performance Portal relationship. You can unsubscribe from receiving this information at any time. </p><br><p>All fields marked with a * are mandatory.</p>" />
                                                </p>
                                                <br>
                                                <p>
                                                    <v-text-field variant="outlined"
                                                        :color="emailDomainFound ? 'green-lighten-1' : undefined"
                                                        :bg-color="emailDomainFound ? 'green-lighten-5' : undefined"
                                                        v-model="registerEmailAddress"
                                                        :readonly="organizationFound == false || emailDomainFound == true"
                                                        type="email" autocomplete="email" aria-label="Business email address">
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder
                                                                 is-html
                                                                :element-visible="processWindow == 'capture-registration-info'"
                                                                default-text="Business email address" />
                                                        </template>
                                                        <template v-slot:append-inner>
                                                            <v-btn variant="text" class="text-none" size="small"
                                                                :color="emailDomainFound ? 'green-darken-3' : undefined">
                                                                <LanguagePlaceholder
                                                                     is-html
                                                                    :element-visible="processWindow == 'capture-registration-info'"
                                                                    default-text="Search" />
                                                            </v-btn>

                                                        </template>
                                                    </v-text-field>
                                                </p>
                                                <p>
                                                    <v-text-field variant="outlined"
                                                        :color="organizationFound ? 'green-lighten-1' : undefined"
                                                        :bg-color="organizationFound ? 'green-lighten-5' : undefined"
                                                        v-model="selectedOrganization.accountName"
                                                        :readonly="organizationFound == false || emailDomainFound == true"
                                                        autocomplete="organization" aria-label="Organization Name">
                                                        <template v-slot:append-inner>
                                                            <v-btn variant="text" class="text-none" size="small"
                                                                :color="emailDomainFound ? 'green-darken-3' : undefined" aria-label="Search organization">Search</v-btn>
                                                        </template>
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder
                                                                is-html
                                                                :element-visible="processWindow == 'capture-registration-info'"
                                                                default-text="Organization Name" />
                                                        </template>
                                                    </v-text-field>
                                                </p>
                                                <p v-if="selectedOrganization?.country">
                                                    <v-text-field variant="outlined"
                                                        :model-value="selectedOrganization.country"
                                                        readonly
                                                        aria-label="Organisation country"
                                                        aria-readonly="true">
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder
                                                                is-html
                                                                :element-visible="processWindow == 'capture-registration-info'"
                                                                default-text="Country" />
                                                        </template>
                                                    </v-text-field>
                                                </p>
                                                <p v-if="isExistingOrganization === false && selectedOrganization?.country && distributorsForCountry.length > 0">
                                                    <p class="text-caption text-medium-emphasis mt-n2 mb-2">
                                                        <LanguagePlaceholder
                                                            is-html
                                                            :element-visible="processWindow == 'capture-registration-info'"
                                                            default-text="This information allows us to identify who referred you to the RISE Program and will be used for statistical purposes only." />
                                                    </p>
                                                    <v-select
                                                        v-model="sponsoredDistributorSelection"
                                                        :items="sponsoredDistributorItems"
                                                        item-title="accountName"
                                                        return-object
                                                        variant="outlined"
                                                        aria-label="Who referred you to RISE?">
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder
                                                                is-html
                                                                :element-visible="processWindow == 'capture-registration-info'"
                                                                default-text="Who referred you to RISE?" />
                                                        </template>
                                                    </v-select>
                                                </p>
                                                <p>
                                                    <v-text-field variant="outlined" v-model="registerFirstname" 
                                                        autocomplete="given-name" aria-label="First name" aria-required="true" required>
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder
                                                                 is-html
                                                                :element-visible="processWindow == 'capture-registration-info'"
                                                                default-text="* Firstname" />
                                                        </template>
                                                    </v-text-field>
                                                </p>
                                                <p>
                                                    <v-text-field variant="outlined" v-model="registerSurname" 
                                                        autocomplete="family-name" aria-label="Surname" aria-required="true" required>
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder
                                                                is-html
                                                                :element-visible="processWindow == 'capture-registration-info'"
                                                                default-text="* Surname" />
                                                        </template>
                                                    </v-text-field>
                                                </p>
                                                <p>
                                                    <v-text-field variant="outlined" v-model="registerTelephone" 
                                                        type="tel" autocomplete="tel" aria-label="Telephone" aria-required="true" required>
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder
                                                                 is-html
                                                                :element-visible="processWindow == 'capture-registration-info'"
                                                                default-text="* Telephone" />
                                                        </template>
                                                    </v-text-field>
                                                </p>
                                                <p>
                                                    <v-text-field variant="outlined" v-model="registerMobile" 
                                                        type="tel" autocomplete="tel-national" aria-label="Mobile phone">
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder
                                                                 is-html
                                                                :element-visible="processWindow == 'capture-registration-info'"
                                                                default-text="Mobile" />
                                                        </template>
                                                    </v-text-field>
                                                </p>
                                                <p>
                                                    <v-select v-model="registerSelectedPerferredLanguage" return-object
                                                        item-title="language" item-value="id"
                                                        :items="registrationStore.languages" variant="outlined">
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder
                                                                 is-html
                                                                :element-visible="processWindow == 'capture-registration-info'"
                                                                default-text="* Select Preferred Language" />
                                                        </template>
                                                    </v-select>
                                                </p>
                                                <p>
                                                    <LanguagePlaceholder 
                                                        is-html
                                                        :element-visible="processWindow == 'capture-registration-info'"
                                                        default-text="Dell Technologies and its group of companies ('Dell') would like to stay in touch and update on on products, services, solutions, exclusive offers and special events. for more details about our information practices, read our <route class='blue-link body-bold' route-name='privacy-statement'>Privacy Statement.</route> You can unsubscribe at any time." />

                                                </p>
                                                <p>
                                                    <v-checkbox>
                                                        <template v-slot:label>
                                                            <LanguagePlaceholder
                                                                 is-html
                                                                :element-visible="processWindow == 'capture-registration-info'"
                                                                default-text="Yes, I would like Dell Technologies to contact me by email." />
                                                        </template>
                                                    </v-checkbox>
                                                </p>
                                                <p>
                                                    <LanguagePlaceholder 
                                                        is-html
                                                        :element-visible="processWindow == 'capture-registration-info'"
                                                        default-text="For detailed information on the cookies we use and the purposes for which we use them see our <route class='blue-link body-bold' route-name='cookie-policy'></route>" />
                                                </p>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-btn class="text-none" @click="goTo('login')" width="100"
                                                    variant="tonal">
                                                    <LanguagePlaceholder 
                                                        is-html
                                                        :element-visible="processWindow == 'capture-registration-info'"
                                                        default-text="Cancel" />
                                                </v-btn>
                                                <v-spacer></v-spacer>
                                                <v-btn class="text-none" width="100"
                                                    @click="processWindow = 'accept-terms-and-conditions'"
                                                    :disabled="!validateRegistrationInfo" color="#055699"
                                                    variant="elevated">
                                                    <LanguagePlaceholder 
                                                        is-html
                                                        :element-visible="processWindow == 'capture-registration-info'"
                                                        default-text="Next" />
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-window-item>
                                    <v-window-item value="accept-terms-and-conditions">
                                        <v-card>
                                            <v-card-title>
                                                <LanguagePlaceholder 
                                                    is-html
                                                    :element-visible="processWindow == 'accept-terms-and-conditions'"
                                                    default-text="Accept Terms and Conditions" />
                                            </v-card-title>
                                            <v-card-text>
                                                <v-btn v-if="isExistingOrganization === false" class="my-4 text-none"
                                                    @click="showRISETermsAndConditions = true" variant="tonal"
                                                    :color="acceptedRISETermsAndConditions === true ? 'success' : 'error'"
                                                    :append-icon="acceptedRISETermsAndConditions === true ? 'mdi-check-circle' : 'mdi-close-circle'"
                                                    block>
                                                    <template v-slot:append>
                                                        <v-icon
                                                            :color="acceptedRISETermsAndConditions === true ? 'success' : 'error'"></v-icon>
                                                    </template>

                                                    <LanguagePlaceholder 
                                                        is-html
                                                        :element-visible="processWindow == 'accept-terms-and-conditions'"
                                                        default-text="View RISE Terms & Conditions" />
                                                </v-btn>
                                                <v-btn class="my-4 text-none"
                                                    @click="showPortalTermsAndConditions = true" variant="tonal"
                                                    :color="acceptedPortalTermsAndConditions === true ? 'success' : 'error'"
                                                    :append-icon="showPortalTermsAndConditions === true ? 'mdi-check-circle' : 'mdi-close-circle'"
                                                    block>
                                                    <template v-slot:append>
                                                        <v-icon
                                                            :color="acceptedPortalTermsAndConditions === true ? 'success' : 'error'"></v-icon>
                                                    </template>

                                                    <LanguagePlaceholder 
                                                        is-html
                                                        :element-visible="processWindow == 'accept-terms-and-conditions'"
                                                        default-text="View Portal Terms & Conditions" />
                                                </v-btn>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-btn class="text-none" @click="goTo('login')" width="100"
                                                    variant="tonal">
                                                    <LanguagePlaceholder 
                                                        is-html
                                                        :element-visible="processWindow == 'accept-terms-and-conditions'"
                                                        default-text="Cancel" />
                                                </v-btn>
                                                <v-spacer></v-spacer>
                                                <v-btn class="text-none" width="200" @click="clickSubmitRegistration()"
                                                    :disabled="!canSubmitRegistration" color="#055699"
                                                    variant="elevated">
                                                    <LanguagePlaceholder 
                                                        is-html
                                                        :element-visible="processWindow == 'accept-terms-and-conditions'"
                                                        default-text="Submit Registration" />
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-window-item>
                                    <v-window-item value="registration-confirmation">
                                        <v-card>
                                            <v-card-text>
                                                <v-sheet class="pa-4 text-center mx-auto" max-width="600" rounded="lg"
                                                    width="100%">
                                                    <v-icon class="mb-5" color="#055699" icon="mdi-check-circle"
                                                        size="112"></v-icon>

                                                    <h2 class="text-h5 mb-6">
                                                        <LanguagePlaceholder
                                                             is-html
                                                            :element-visible="processWindow == 'registration-confirmation'"
                                                            default-text="Registration complete" />

                                                    </h2>

                                                    <p class="mb-4 text-medium-emphasis text-body-2">
                                                        You can now log in using <strong>{{ registerEmailAddress
                                                            }}</strong> as your username and password.
                                                        <br>
                                                        You will be then prompted to create a new password.
                                                    </p>

                                                    <v-divider class="mb-4"></v-divider>

                                                    <div class="text-end">

                                                    </div>
                                                </v-sheet>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn @click="goTo('login')" class="text-none" color="#055699"
                                                    variant="flat" width="100">
                                                    <LanguagePlaceholder 
                                                        is-html
                                                        :element-visible="processWindow == 'registration-confirmation'"
                                                        default-text="Done" />
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-window-item>
                                </v-window>
                            </v-col>


                        </v-row>

                    </v-card-text>
                </v-card>
            </v-row>
        </v-container>

        <v-footer height="45" color="#212529" padless app role="contentinfo">
            <v-row justify="center" no-gutters>
                <ul class="navigation-list" role="list" aria-label="Footer navigation menu">
                    <li>
                        <v-btn variant="text" @click="systemStore.routerTo('noauth-terms-of-use')"
                            class="my-2 mx-2 text-white text-none" aria-label="Terms Of Use" @keydown.enter="systemStore.routerTo('noauth-terms-of-use')" @keydown.space.prevent="systemStore.routerTo('noauth-terms-of-use')" tabindex="0" role="link">
                            <LanguagePlaceholder is-html position="fixed"
                                default-text="Terms Of Use" />
                        </v-btn>
                    </li>
                    <li>
                        <v-btn variant="text" @click="systemStore.routerTo('noauth-privacy-statement')"
                            class="my-2 mx-2 text-white text-none" aria-label="Privacy Statement" @keydown.enter="systemStore.routerTo('noauth-privacy-statement')" @keydown.space.prevent="systemStore.routerTo('noauth-privacy-statement')" tabindex="0" role="link">
                            <LanguagePlaceholder is-html position="fixed"
                                default-text="Privacy Statement" />
                        </v-btn>
                    </li>
                    <li>
                        <v-btn variant="text" @click="systemStore.routerTo('noauth-cookies-information')"
                            class="my-2 mx-2 text-white text-none" aria-label="Cookies Information" @keydown.enter="systemStore.routerTo('noauth-cookies-information')" @keydown.space.prevent="systemStore.routerTo('noauth-cookies-information')" tabindex="0" role="link">
                            <LanguagePlaceholder is-html position="fixed"
                                default-text="Cookies Information" />
                        </v-btn>
                    </li>
                </ul>
            </v-row>
        </v-footer>

        <v-dialog persistent v-model="showVideo" width="650">
            <v-card width="650">
                <v-card-title></v-card-title>
                <v-card-text>
                    <video width="600" height="338" controls preload="none"
                        poster="https://dellpartnerincentives.com/siteassets/WelcomeToRiseVideo/welcome-to-rise-poster.png">
                        <source
                            src="https://dellpartnerincentives.com/siteassets/WelcomeToRiseVideo/735114 Dell - RISE - Existing Partners (Welcome) (ENG).mp4"
                            type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="showVideo = false" width="100">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="showOrganizationSearchResults" width="500" height="350">
            <v-card>
                <v-card-title>
                    <LanguagePlaceholder is-html
                        default-text="Organization search result(s)" />
                    
                </v-card-title>
                <v-card-text>
                    <v-list>
                        <v-list-item v-for="(item, idx) in searchOrganizationResults" :key="idx" :value="item"
                            rounded="xl" @click="selectedOrganization = item" color="primary">
                            <v-list-item-title v-text="item.accountName"></v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="cancelSelectOrganization()" width="100" variant="tonal">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn width="100" :disabled="selectedOrganization == null" @click="selectOrganization()"
                        color="#055699" variant="elevated">
                        <LanguagePlaceholder is-html
                        default-text="Select" />
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="showRISETermsAndConditions" fullscreen>
            <v-card>
                <v-card-title>
                    <LanguagePlaceholder is-html default-text="RISE Terms and Conditions" />
                </v-card-title>
                <v-card-text>
                    <RISETermsAndConditions />
                    <v-switch v-model="acceptedRISETermsAndConditions"
                        :color="acceptedRISETermsAndConditions === true ? 'success' : 'error'"
                        >
                        <template v-slot:label>
                            <LanguagePlaceholder is-html default-text="Accept RISE Terms and Conditions" />
                        </template>
                    </v-switch>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="showRISETermsAndConditions = false">Close</v-btn>
                    <v-btn width="100" @click="clickSaveRISETermsAndConditions()" color="#055699"
                        variant="elevated">
                            <LanguagePlaceholder  default-text="Save" />   
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="showPortalTermsAndConditions" fullscreen>
            <v-card>
                <v-card-title>
                    <LanguagePlaceholder is-html default-text="Portal Terms and Conditions" />
                </v-card-title>
                <v-card-text>
                    <PortalTermsAndConditions />
                </v-card-text>
                <v-card-actions>
                    <v-switch v-model="acceptedPortalTermsAndConditions"
                        :color="acceptedPortalTermsAndConditions === true ? 'success' : 'error'"
                        >
                        <template v-slot:label>
                            <LanguagePlaceholder is-html default-text="Accept Portal Terms and Conditions" />
                        </template>
                    </v-switch>
                    <v-spacer></v-spacer>
                    <v-btn text @click="showPortalTermsAndConditions = false">Close</v-btn>
                    <v-btn width="100" @click="clickSavePortalTermsAndConditions()" color="#055699"
                        variant="elevated">
                        <LanguagePlaceholder is-html default-text="Save" />
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>




</template>

<script setup>
import router from '../router'
import { ref, onMounted, watch, computed } from 'vue'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import PortalTermsAndConditions from '@/components/PortalTermsAndConditions.vue'
import RISETermsAndConditions from '@/components/RISETermsAndConditions.vue'

import { useSystemStore } from '@/stores/system'
import { useAuthStore } from '@/stores/auth'
import { useRegistrationStore } from '@/stores/registration'

const authStore = useAuthStore()
const systemStore = useSystemStore()
const registrationStore = useRegistrationStore()

const processWindow = ref('captcha')
const captchaToken = ref('')
const captchaSuccess = ref(false)
const showVideo = ref(false)

const isDellPartner = ref(null)
const affinityId = ref('')
// const affinityIdMatchedRecord = ref({})
const affinityIdChecked = ref(false)

const selectedCountry = ref(null)
const selectedOrganization = ref(null)
const registerEmailAddress = ref('')
const emailDomainFound = ref(false)
const searchEmailDomainMatchedRecord = ref({})
const organizationFound = ref(false)
const searchOrganizationNameString = ref('')
const searchOrganizationResults = ref([])
const showOrganizationSearchResults = ref(false)

const registerFirstname = ref('')
const registerSurname = ref('')
const registerTelephone = ref('')
const registerMobile = ref('')
const registerSelectedPerferredLanguage = ref(null)
const registerCommunicationsOptIn = ref(false)
const sponsoredDistributorSelection = ref(null)
const distributorsForCountry = ref([])

const STATIC_SPONSORED_OPTIONS = [
    { affinityId: null, accountName: 'None', channel: null },
    { affinityId: null, accountName: 'RISE Communications',     channel: 'RISE Communications' },
    { affinityId: null, accountName: 'Dell Representative', channel: 'Dell Representative' },
]

const sponsoredDistributorItems = computed(() => [
    ...STATIC_SPONSORED_OPTIONS,
    ...distributorsForCountry.value.map(d => ({ ...d, channel: null })),
])
const acceptedRISETermsAndConditions = ref(false)
const acceptedPortalTermsAndConditions = ref(false)
const showRISETermsAndConditions = ref(false)
const showPortalTermsAndConditions = ref(false)
const isExistingUser = ref(false)
const isExistingOrganization = ref(false)
const isExistingOrganizationActive = ref(false)
const existingOrganization = ref(null)

onMounted(() => {
    // processWindow.value = 'accept-terms-and-conditions'
    registrationStore.GetEMEACountries()
    registrationStore.GetAllLanguages()
})

watch(
    () => isDellPartner.value, (val) => {
        if (val === false) {
            openDellPartnerPortal()
        }
    }
)

watch(
    () => processWindow.value, (val) => {
        if (val === 'capture-registration-info' && selectedOrganization.value?.country) {
            registrationStore.GetDistributorsByCountry(selectedOrganization.value.country).then(res => {
                distributorsForCountry.value = res.distributors ?? []
            }).catch(() => {
                distributorsForCountry.value = []
            })
        }
    }
)

const validateRegistrationInfo = computed(() => {
    if (registerFirstname.value.length === 0) {
        return false
    }

    if (registerSurname.value.length === 0) {
        return false
    }

    if (registerTelephone.value.length === 0) {
        return false
    }

    // not mandatory
    // if (registerMobile.value.length === 0) {
    //     return false
    // }

    if (registerSelectedPerferredLanguage.value === undefined || registerSelectedPerferredLanguage.value === null) {
        return false
    }

    return true
})

const canSubmitRegistration = computed(() => {
    if (isExistingOrganization.value === false && acceptedRISETermsAndConditions.value === false) {
        return false
    }

    if (acceptedPortalTermsAndConditions.value === false) {
        return false
    }

    return true
})

const canContinueToRegistrationInfo = computed(() => {
    if (emailDomainFound.value !== true) {
        return false
    }

    if (isExistingOrganization.value == true && isExistingOrganizationActive.value !== true) {
        return false
    }

    return true
})

const moveToCaptureRegistrationInfo = () => {

    if (affinityIdChecked.value == false || emailDomainFound.value == false || (isExistingOrganization.value === true && isExistingOrganizationActive.value != true)){
        systemStore.showMessage('Unable to proceed, not all qualifying criteria was met in order to proceed to the next step.', { color: 'error'})
    } else {
        processWindow.value = 'capture-registration-info'
    }
}

const clickSubmitRegistration = () => {
    registrationStore.SubmitRegistration(selectedOrganization.value.affinityId, registerEmailAddress.value, registerFirstname.value, registerSurname.value, registerSelectedPerferredLanguage.value.id, registerTelephone.value, registerMobile.value, registerCommunicationsOptIn.value, sponsoredDistributorSelection.value?.affinityId ?? null, sponsoredDistributorSelection.value?.channel ?? null).then(res => {
        if (res.success === true) {
            processWindow.value = 'registration-confirmation'
        }
    }).catch(error => {
        // systemStore.showMessage('Registration Failed, organization exists but not active. Please contact support@dellpartnerincentives.com to request assistance.', {color: 'error'})
    })

}

const clickSaveRISETermsAndConditions = () => {
    showRISETermsAndConditions.value = false
}

const clickSavePortalTermsAndConditions = () => {
    showPortalTermsAndConditions.value = false
}

const openDellPartnerPortal = () => {
    window.open('https://www.delltechnologies.com/partner/en-gb/partner/partner.htm', '_blank').focus();
}

const selectOrganization = () => {
    organizationFound.value = true
    showOrganizationSearchResults.value = false
    searchOrganizationNameString.value = selectedOrganization.value.accountName

    registrationStore.GetOrganizationByAffinityId(selectedOrganization.value.affinityId).then(res => {
        if (res.success === true && res.isExistingOrganization === true) {
            isExistingOrganization.value = true
            existingOrganization.value = res.searchResult

            if (existingOrganization.value.statusLink !== 1 || existingOrganization.value.isDistributor === true) {
                isExistingOrganizationActive.value = false
                systemStore.showMessage('Unable to continue, organization exists but is not active or listed as a distributor. Please contact support@dellpartnerincentives.com to request assistance.', { color: 'error' })
            } else {
                isExistingOrganizationActive.value = true
            }
        } else {
            isExistingOrganization.value = false
            existingOrganization.value = null
        }
    }).catch(error => {

    })
}

const cancelSelectOrganization = () => {
    organizationFound.value = false
    showOrganizationSearchResults.value = false
    selectedOrganization.value = null
}

const clickClearOrganization = () => {
    organizationFound.value = false
    selectedOrganization.value = null
}

const updateCaptchaToken = (token, ekey) => {
    var t = token
    authStore.hCaptchaSiteVerify(token).then(res => {
        captchaSuccess.value = res.success

        if (captchaSuccess.value == true) {
            processWindow.value = 'dell-partner'
        } else {
            // TODO: SHOW MESSAGE
        }

    })
}

const searchEmailDomain = () => {
    var aId = processWindow.value == 'affinity-id-lookup' ? affinityId.value :
        processWindow.value == 'email-domain-lookup' ? selectedOrganization.value.affinityId : 0

    if (aId != 0 && registerEmailAddress.value.length > 3 && emailDomainFound.value !== true) {
        // first check if email address is already registered on portal
        registrationStore.IsExistingUser(registerEmailAddress.value).then(res => {
            if (res.isExistingUser === true) {
                systemStore.showMessage('Unable to continue, email address is already registered on the portal. Please contact support@dellpartnerincentives.com to request assistance.', { color: 'error' })
            } else {
                // email address not yet registered, find domain match
                registrationStore.FindEmailDomainMatch(registerEmailAddress.value, aId).then(res => {
                    if (res.success) {
                        emailDomainFound.value = true
                        systemStore.showMessage('Domain (' + res.emailDomain + ') match found.', { color: 'success' })
                    } else {
                        emailDomainFound.value = false
                        systemStore.showMessage('Your email domain does not match your Partner details on file. Please contact support@dellpartnerincentives.com to request assistance.', { color: 'warning' })
                    }
                }).catch(error => {
                    var t = error
                })
            }
        }).catch(error => {
            systemStore.showMessage('Error checking existing user', { color: 'error' })
        })


    } else {
        // show message box
    }
}

const searchOrganizationName = () => {
    if (searchOrganizationNameString.value.length >= 2 && organizationFound.value !== true) {
        registrationStore.searchOrganization(selectedCountry.value.country, searchOrganizationNameString.value).then(res => {
            if (res.success) {
                organizationFound.value = true
                searchOrganizationResults.value = res.matchedRecords
                systemStore.showMessage(res.matchedRecords.length + ' result(s) found, please select the correct one.', { color: 'success' })
                showOrganizationSearchResults.value = true
            } else {
                organizationFound.value = false
                systemStore.showMessage('no results found.', { color: 'warning' })
            }
        }).catch(error => {
            var t = error
        })
    } else {
        // show message box
    }
}

const checkAffinityId = () => {
    if (affinityId.value.length > 3 && affinityIdChecked.value !== true) {
        registrationStore.searchAffinityId(affinityId.value).then(res => {
            if (res.success) {
                affinityIdChecked.value = true
                selectedOrganization.value = res.matchedRecords[0]
                selectOrganization()
                systemStore.showMessage('Affinity id found.', { color: 'success' })
            } else {
                affinityIdChecked.value = false
                systemStore.showMessage('no results found.', { color: 'warning' })
            }
        }).catch(error => {
            var t = error
        })
    } else {
        // show message box
    }
}

const languageItems = [
    { title: 'Français', language: 'FRANCAIS' },
    { title: 'Deutsch', language: 'DEUTSCH' },
    { title: 'Español', language: 'ESPANOL' },
    { title: 'Italiano', language: 'ITALIANO' },
    { title: 'English', language: 'ENGLISH' },
    { title: 'Polski', language: 'POLSKI' },
    { title: 'Türkçe', language: 'TURKISH' },
]

const icons = [
    'mdi-home',
    'mdi-email',
    'mdi-calendar',
    'mdi-delete'
]

const links = [
    { text: '© Dell Technologies 2024', enabled: false },
    { text: 'Terms Of Use', enabled: true },
    { text: 'Privacy Statement', enabled: true },
    { text: 'Cookies Information', enabled: true },
    { text: 'Contact', enabled: true }
]

const goTo = (routeName) => {
    if (routeName !== undefined) {
        router.push({ name: routeName })
    }
}

</script>

<style scoped>
.bg {
    width: 100%;
    height: calc(100%);
    background: url('../img/login-bg.jpg');
    background-size: cover;
}

/* Navigation list styling for accessibility - removes default list styling while maintaining semantic structure */
.navigation-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
}

.navigation-list li {
    display: inline-block;
    margin: 0;
    padding: 0;
}
</style>